import { BaseEntity } from "./base-entity.model";

export enum Role {
  TRAVEL_ADVISOR = "TRAVEL_ADVISOR",
  CUSTOMER = "CUSTOMER",
  ADMIN = "ADMIN"
}

export class User extends BaseEntity {
  displayName: string;
  email: string;
  photoUrl: string;
  roles: Role[];

  hasRole(role: Role): boolean {
    return this.roles ? this.roles.indexOf(role) >= 0 : false;
  }

  constructor(object: object = {}) {
    super(object);
  }
}
